module.exports = __webpack_public_path__ + "static/img/setting-outlined.16c94a7f.svg";